import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getMobileSdkTestDetails } from 'src/apps/mobile-sdk/services/MobileSdkDashboardService';
import { IMobileSdkTestDetails } from 'src/apps/mobile-sdk/types/MobileSdkServiceTypes';
import { MOBILE_SDK_TEST_DETAILS } from 'src/common/providers/reactQueryProvider/QueryKeys';

export const useMobileSdkTestDetailsQuery = (
	testId: string
): UseQueryResult<IMobileSdkTestDetails | null> => {
	const testDetailsQuery = useQuery([MOBILE_SDK_TEST_DETAILS, testId], () =>
		getMobileSdkTestDetails(testId)
	);

	return testDetailsQuery;
};
